export default __webpack_public_path__ + "static/media/emptyStateEvaluation.ee32f538.svg";